import alerts from './plugins/alerts'
import App from './App.vue'
import auth from './plugins/auth'
import dropDown from './plugins/dropdown'
import DatePicker from './plugins/datepicker/es'
import files from './plugins/files'
import filters from './plugins/filters'
import i18n from './plugins/languages/i18n'
import JsonExcel from 'vue-json-excel'
import lang from './plugins/languages'
import modal from './plugins/modal'
import OrganismTheHeader from './components/organisms/OrganismTheHeader'
import paypal from './plugins/gateways/paypal'
import router from './router'
import services from './plugins/services'
import store from './store'
import stripe from './plugins/gateways/stripe'
import utils from './plugins/utils'
import validation from './plugins/validation'
import Vue from 'vue'
import Vuelidate from 'vuelidate'

// Registración global de todos los componentes atoms
const requireComponent = require.context(
  './components',
  true,
  /Atom[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  Vue.component(
    fileName.replace('./atoms/', '').replace('.vue', ''),
    componentConfig.default || componentConfig
  )
})

// Registración global del componente DatePicker
Vue.component('DatePicker', DatePicker)

// Registración global del componente único TheHeader
Vue.component('OrganismTheHeader', OrganismTheHeader)

// Registración global de plugins
Vue.use(alerts)
Vue.use(auth)
Vue.use(dropDown)
Vue.use(files)
Vue.use(filters)
Vue.component('downloadExcel', JsonExcel)
Vue.use(lang)
Vue.use(modal)
Vue.use(paypal)
Vue.use(services)
Vue.use(stripe)
Vue.use(utils)
Vue.use(validation)
Vue.use(Vuelidate)
Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
